import React, { useState, useEffect } from 'react'
import './style.css'
import Button from '../CtaButton'
import ServicesBannerForm from '../services-banner-from/ServicesBannerForm'
import useIsMobile from '../../hooks/useIsMobile'
import { truncateWords } from '../../utils/textUtils'

const ServicesPageBanner = ({ shortHeading, mainHeading, description, icons }) => {

    const isMobile = useIsMobile()

    return (
        <>
            <div className="services-page-banner-main-box">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-12 service-banner-text-area">
                            <div className="services-page-banner-text-box">
                                <h1 className='low-top-heading'>{shortHeading}</h1>
                                <p className="capital-main-heading" dangerouslySetInnerHTML={{ __html: mainHeading }} />
                                <p className="description-text banner-description-text">{isMobile ? truncateWords(description, 10) : description}</p>
                                {/* <div className="mt-4">
                                    <Button text='Talk to Our AI ML Experts' link='/contact-us' />
                                </div> */}

                                {icons ? <div className="services-banner-rating-icon">
                                    {icons?.map((image, index) => {
                                        return <a href="#" target='_blank' key={index}>
                                            <img src={image} width={90} alt="" />
                                        </a>
                                    })}
                                </div> : <div className="services-banner-rating-icon">
                                    <a href="https://www.youtube.com/watch?v=LDmv2CrkM1c" target='_blank'>
                                        <img src="/images/new-Payoneer.svg" className='payoneer-image-service-banner' width={160} alt="Best Web Development Company Awarded by Payoneer" />
                                    </a>
                                    <a href="https://clutch.co/profile/bitsclan-it-solutions?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=logo&utm_term=bitsclan.com#highlights" target='_blank'>
                                        <img src="/images/new-clutch.svg" className='clutch-image-service-banner' width={120} alt="Bitsclan IT Solutions Trusted by Clutch" />
                                    </a>
                                </div>}
                            </div>
                        </div>

                        <div className="col-xl-4 col-lg-4 service-banner-text-area mt-5 mt-lg-0">
                            <ServicesBannerForm />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServicesPageBanner